export const delayForLoadingScreen = 300;
export const flashMessageTime = 5000;
export enum FlashMessageType {
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
  Info = 'info',
}

export const Colors = {
  cerulean: '#009EE5',
  black: '#000000',
  burntSienna: '#EF5350',
  orangePeel: '#FF9800',
  fruitSalad: '#4CAF50',
  ceruleanDark: '#03A9F4',
  mobster: '#79747E',
  gray: '#79747E',
  white: '#FFFFFF',
  red: '#DB2B2B',
};

export const SIZE_LIMIT_BYTES = 99_614_720; // 95 MB limit for one part of MRI's

export const FULL_WIDTH_TO_ASCII_OFFSET = 0xfee0;
export const ZK_LIST = [
  '。',
  '「',
  '」',
  '、',
  '・',
  'ヲ',
  'ァ',
  'ィ',
  'ゥ',
  'ェ',
  'ォ',
  'ャ',
  'ュ',
  'ョ',
  'ッ',
  'ー',
  'ア',
  'イ',
  'ウ',
  'エ',
  'オ',
  'カ',
  'キ',
  'ク',
  'ケ',
  'コ',
  'サ',
  'シ',
  'ス',
  'セ',
  'ソ',
  'タ',
  'チ',
  'ツ',
  'テ',
  'ト',
  'ナ',
  'ニ',
  'ヌ',
  'ネ',
  'ノ',
  'ハ',
  'ヒ',
  'フ',
  'ヘ',
  'ホ',
  'マ',
  'ミ',
  'ム',
  'メ',
  'モ',
  'ヤ',
  'ユ',
  'ヨ',
  'ラ',
  'リ',
  'ル',
  'レ',
  'ロ',
  'ワ',
  'ン',
  '゛',
  '゜',
  'ヺ',
  'ヴ',
  'ガ',
  'ギ',
  'グ',
  'ゲ',
  'ゴ',
  'ザ',
  'ジ',
  'ズ',
  'ゼ',
  'ゾ',
  'ダ',
  'ヂ',
  'ヅ',
  'デ',
  'ド',
  'バ',
  'パ',
  'ビ',
  'ピ',
  'ブ',
  'プ',
  'ベ',
  'ペ',
  'ボ',
  'ポ',
  'ヷ',
];
export const HK_LIST = [
  '｡',
  '｢',
  '｣',
  '､',
  '･',
  'ｦ',
  'ｧ',
  'ｨ',
  'ｩ',
  'ｪ',
  'ｫ',
  'ｬ',
  'ｭ',
  'ｮ',
  'ｯ',
  'ｰ',
  'ｱ',
  'ｲ',
  'ｳ',
  'ｴ',
  'ｵ',
  'ｶ',
  'ｷ',
  'ｸ',
  'ｹ',
  'ｺ',
  'ｻ',
  'ｼ',
  'ｽ',
  'ｾ',
  'ｿ',
  'ﾀ',
  'ﾁ',
  'ﾂ',
  'ﾃ',
  'ﾄ',
  'ﾅ',
  'ﾆ',
  'ﾇ',
  'ﾈ',
  'ﾉ',
  'ﾊ',
  'ﾋ',
  'ﾌ',
  'ﾍ',
  'ﾎ',
  'ﾏ',
  'ﾐ',
  'ﾑ',
  'ﾒ',
  'ﾓ',
  'ﾔ',
  'ﾕ',
  'ﾖ',
  'ﾗ',
  'ﾘ',
  'ﾙ',
  'ﾚ',
  'ﾛ',
  'ﾜ',
  'ﾝ',
  'ﾞ',
  'ﾟ',
  'ｦﾞ',
  'ｳﾞ',
  'ｶﾞ',
  'ｷﾞ',
  'ｸﾞ',
  'ｹﾞ',
  'ｺﾞ',
  'ｻﾞ',
  'ｼﾞ',
  'ｽﾞ',
  'ｾﾞ',
  'ｿﾞ',
  'ﾀﾞ',
  'ﾁﾞ',
  'ﾂﾞ',
  'ﾃﾞ',
  'ﾄﾞ',
  'ﾊﾞ',
  'ﾊﾟ',
  'ﾋﾞ',
  'ﾋﾟ',
  'ﾌﾞ',
  'ﾌﾟ',
  'ﾍﾞ',
  'ﾍﾟ',
  'ﾎﾞ',
  'ﾎﾟ',
  'ﾜﾞ',
];
